import React, { useState } from "react";

import { StriimTheme } from "@striim/striim-ui-v2";
import { Box, Slide } from "@mui/material";

import PredefinedComponentsDataSource from "../predefinedComponents/predefinedComponentsDataSource";
import CategoryButton from "./Components/CategoryButton";
import { Styles, StylesTheme } from "../../../../../src/utils/types";
import CategoryContent from "./Components/CategoryContent";
import { LeftSidebarCategory } from "./leftSidebar.types";

interface LeftSidebarProps {
    disabled?: boolean;
    visible?: boolean;
}

const LeftSidebar: React.FC<LeftSidebarProps> = ({ visible = true }) => {
    const [data] = useState<LeftSidebarCategory[]>(() => PredefinedComponentsDataSource.loadReact());
    const [selectedCategory, setSelectedCategory] = useState<number | null>(searchIndex);

    if (!visible) return null;

const handleCategoryClick = (categoryIndex: number) => {
    setSelectedCategory(prev =>
        prev === categoryIndex ? null : categoryIndex
    );
};

    return (
        <StriimTheme preselector="">
            <Box sx={styles.root}>
                <Box sx={styles.categories} data-testid="categories" zIndex={1}>
                    <CategoryButton
                        onClick={() => handleCategoryClick(searchIndex)}
                        active={selectedCategory === searchIndex}
                        label="Search"
                    />

                    {data.map((category, i) => (
                        <CategoryButton
                            key={category.categoryLabel}
                            onClick={() => handleCategoryClick(i)}
                            active={selectedCategory === i}
                            label={category.categoryLabel}
                        />
                    ))}
                </Box>

                <Slide direction="right" in={selectedCategory !== null} mountOnEnter unmountOnExit timeout={300}>
                    <Box>
                        {selectedCategory !== null && (
                            <CategoryContent
                                key={selectedCategory}
                                isSearchCategory={selectedCategory === -1}
                                categoryIndex={selectedCategory}
                                data={data}
                                onClose={() => setSelectedCategory(null)}
                            />
                        )}
                    </Box>
                </Slide>
            </Box>
        </StriimTheme>
    );
};

export default LeftSidebar;

const searchIndex = -1; // Less than 0

const styles: Styles = {
    root: {
        height: "calc(100vh - 48px)",
        display: "flex"
    },
    categories: {
        paddingTop: ({ spacing }: StylesTheme) => spacing(2),

        display: "flex",
        padding: [0, 1],
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 2,
        alignSelf: "stretch",

        backgroundColor: ({ palette }: StylesTheme) => palette.background.paper,
        borderRight: ({ palette }: StylesTheme) => `1px solid ${palette.divider}`
    }
};
